<app-related-documents 
(relatedDocumentsSave)="saveOrUpdateDocument()" 
(moveToPreviousTab)="openPreviousTab()"
 [relatedDocumentsNotAlignedWithScopeConfirmationMessage]="documentScopeConfirmationMessage" 
 (relatedDocumentsAddition)="addRelatedDocuments()"
  [showRelatedDocumentsNotAlignedWithScopeConfirmationModal]="showRelatedDocumentsNotAlignedWithScopeConfirmationModal"
  [documentNumbersNotAlignedWithParentDocument]="documentNumbersNotAlignedWithParentDocument"
  [errorMessages]="errorMessages"
  [showDocumentLibrarySearch]="showDocumentLibrarySearch"
  [linkedDocuments]="linkedDocuments"
  [panelListScreen]="documentRelatedDocumentsTab">
</app-related-documents>
<p-dialog
  [(visible)]="showDeletedFilesConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteAttachmentConfirmationMessage }}</span>
  </div>
  <ul>
    <li *ngFor="let deleteAttachment of deletedAttachments">
      {{ deleteAttachment.attachmentName }}
    </li>
  </ul>
  <ng-template pTemplate="footer">
    <p-button
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (onClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (onClick)="showConfirmationPopupForDeletedClientSignatureAttachments()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showDeletedClientSignatureAttachmentConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModalForDeletedClientSignatureAttachments()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteClientSignatureAttachmentConfirmationMessage }}</span>
  </div>
  <ul>
      {{ deletedClientSignatureAttachment?.attachmentName }}
  </ul>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (debounceClick)="addReasonToUpdateDocument()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>

<app-dialog *ngIf="isReasonForDocumentUpdateRequired" [heading]="heading" (saveDocumentwithReason)="saveDocumentwithReason($event)" (isModelOpen)="closeReasonDailog($event)">  
</app-dialog>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField" (confirmed)="saveDocumentwithInactiveAssignmentGroup()" (dialogClosed)="closeConfirmationDailog($event)">
</app-confirmation-dialog>
